type Row = ReadonlyArray< string | number >;
export const downloadAsCsv = (
	rows: ReadonlyArray< Row >,
	filename: string
): void => {
	const csvData = rows
		.map( ( row ) => row.map( escapeCsvCell ).join( ',' ) )
		.join( '\r\n' );
	const csvFile = new Blob( [ csvData ], { type: 'text/csv' } );
	const downloadLink = document.createElement( 'a' );

	downloadLink.style.display = 'none';
	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL( csvFile );
	document.body.appendChild( downloadLink );
	downloadLink.click();
	document.body.removeChild( downloadLink );
};

const escapeCsvCell = ( cell?: number | string ): string => {
	if ( cell === undefined ) {
		return '';
	}
	const sc = cell.toString().trim();
	if ( sc === '' || sc === '""' ) {
		return sc;
	}
	if (
		sc.includes( '"' ) ||
		sc.includes( ',' ) ||
		sc.includes( '\n' ) ||
		sc.includes( '\r' )
	) {
		return '"' + sc.replace( /"/g, '""' ) + '"';
	}
	return sc;
};
